import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';

@Injectable()
export class OrganizationSettingsFiscalYearStore extends ComponentStoreV2Factory {

    public items = computed(() => this.data.getFiscalYears()?.['items'] || []);

}
